import { render, staticRenderFns } from "./account-plan-perks.vue?vue&type=template&id=0b6d4bb9"
import script from "./account-plan-perks.vue?vue&type=script&lang=js"
export * from "./account-plan-perks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports